<div class="complianceScoreBadge" [ngClass]="classes" matTooltip="{{ tooltipText }}" matTooltipPosition="after">
  <div class="complianceScoreBadgeText">{{ score !== undefined ? score + '%' : '--' }}</div>
  <div class="complianceScoreBadgeText score">Score</div>
</div>
